var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51562 8.10938V8.625H5.48438V8.10938V2.48047L3.44336 4.52148L3.07812 4.88672L2.34766 4.15625L2.71289 3.79102L5.63477 0.869141L6 0.503906L6.36523 0.869141L9.28711 3.79102L9.65234 4.15625L8.92188 4.88672L8.55664 4.52148L6.51562 2.48047V8.10938ZM7.20312 7.9375V6.90625H10.4688H11.5V7.9375V10.3438V11.375H10.4688H1.53125H0.5V10.3438V7.9375V6.90625H1.53125H4.79688V7.9375H1.53125V10.3438H10.4688V7.9375H7.20312ZM8.75 9.14062C8.75 8.86133 8.96484 8.625 9.26562 8.625C9.54492 8.625 9.78125 8.86133 9.78125 9.14062C9.78125 9.44141 9.54492 9.65625 9.26562 9.65625C8.96484 9.65625 8.75 9.44141 8.75 9.14062Z",
    fill: "#9DD2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExport);
export default __webpack_public_path__ + "static/media/file-export.09ba62e37acfc53da831e838366bf0ed.svg";
export { ForwardRef as ReactComponent };